import { ReactElement } from 'react';
import { Media } from 'src/utils/media';

export interface NavigationContainerLayoutProps {
  appName: string,
  searchBar: ReactElement,
  pageNavigation: ReactElement,
  marketplacePicker: ReactElement,
}

export const NavigationContainerLayout = ({
  appName,
  searchBar,
  pageNavigation,
  marketplacePicker,

}: NavigationContainerLayoutProps) => (
  <>
    <Media between={['xs', 'md']}>
      <div data-testid="navigation-container-layout-mobile" className="bg-kat-azure">
        <div className="kat-row border border-solid border-x-transparent border-t-transparent border-b-kat-athens px-[2.5%] py-2.5">
          <div className="kat-col-xs-6 px-0">
            <h5 className="mb-0 pt-1 pb-0">{appName}</h5>
          </div>
          <div className="kat-col-xs-6 flex justify-end px-0">
            {marketplacePicker}
          </div>
        </div>
        {searchBar}
        <div className="border border-solid border-x-transparent border-t-transparent border-b-kat-athens px-[1.5%] ">
          {pageNavigation}
        </div>
      </div>
    </Media>
    <Media greaterThanOrEqual="md">
      <div data-testid="navigation-container-layout-desktop" className="kat-row bg-kat-azure px-[2.5%]">
        <div className="kat-col-md-10 px-0">
          {pageNavigation}
        </div>
        <div className="kat-col-md-2 flex justify-end py-2.5 px-0 ">
          {marketplacePicker}
        </div>
      </div>
      {searchBar}
    </Media>
  </>
);
